import Wizard from './Wizard';
import './Wizard.css';

export default Wizard;



// WEBPACK FOOTER //
// ./src/components/Wizard/index.ts